export default function DownArrowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
    >
      <path
        d="M5.43514 8.855L1.83814 4.7435C1.41364 4.25975 1.75864 3.5 2.40289 3.5H9.59689C9.74107 3.49988 9.88223 3.54132 10.0035 3.61936C10.1247 3.6974 10.2209 3.80873 10.2805 3.94002C10.3401 4.07131 10.3605 4.217 10.3395 4.35963C10.3184 4.50227 10.2567 4.6358 10.1616 4.74425L6.56464 8.85425C6.49424 8.93481 6.40743 8.99937 6.31002 9.04361C6.21261 9.08785 6.10687 9.11074 5.99989 9.11074C5.8929 9.11074 5.78716 9.08785 5.68975 9.04361C5.59235 8.99937 5.50553 8.93481 5.43514 8.85425V8.855Z"
        fill="white"
      />
    </svg>
  );
}
